(function(){
  function init(root){
    if(root.__soiStd) return; root.__soiStd = true;
    var btns = root.querySelectorAll('.soi-std__c');
    var panel = root.querySelector('.soi-std__panel-in');
    if(!btns.length || !panel) return;
    function show(b){
      btns.forEach(function(x){ x.classList.remove('is-on'); x.setAttribute('aria-selected','false'); });
      b.classList.add('is-on'); b.setAttribute('aria-selected','true');
      var nm = b.querySelector('.soi-std__nm');
      var ds = b.querySelector('.soi-std__desc-src');
      panel.querySelector('h3').textContent = nm ? nm.textContent : '';
      panel.querySelector('p').textContent = ds ? ds.textContent : '';
    }
    btns.forEach(function(b){ b.addEventListener('click', function(){ show(b); }); });
    show(btns[0]);
  }
  function scan(){ document.querySelectorAll('[data-soi-std]').forEach(init); }
  if(document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
})();

document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-soi-copy]');
  if (!b) return;
  var code = b.getAttribute('data-soi-copy');
  if (navigator.clipboard) navigator.clipboard.writeText(code);
  var old = b.innerHTML;
  b.classList.add('is-copied');
  b.innerHTML = 'Code copied';
  setTimeout(function () { b.innerHTML = old; b.classList.remove('is-copied'); }, 1800);
});